// 积分记录api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'UserPoints/List',
        method: 'post',
        data
    })
}